export const STRIPE_KEY = process.env.STRIPE_KEY;
export const STRIPE_SECRET = process.env.STRIPE_SECRET;
export const STRIPE_WEBHOOK_SECRET = process.env.STRIPE_WEBHOOK_SECRET;
export const STRIPE_REDIRECT_CHECKOUT_URL = '/payment/';
